import { AppBar, Badge, Box, Button, IconButton, Toolbar } from '@mui/material';
import { Link } from 'react-router-dom';
import UserMenu from './UserMenu';
import logo from '../../../assets/rwth_wzl_logo_blau3.jpg';
import { Trans } from 'react-i18next';
import LanguageMenu from './LanguageMenu';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { useEffect, useState } from 'react';
import { setNewResult } from '../../../store/pipeline/pipelineSlice';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HelpIcon from '@mui/icons-material/Help';
import LanguageIcon from '@mui/icons-material/Language';
import { enableTut, togglePauseTut } from '../../../store/tutorial/tutorialSlice';

const NavigationBar = (): JSX.Element => {
  const newResult = useAppSelector(state => state.pipeline.newResult);
  const dispatch = useAppDispatch();
  const tutorial = useAppSelector(state => state.tutorial);

  const handleResultsClick = () => {
    dispatch(setNewResult(false));
    if(tutorial.active && !tutorial.paused && tutorial.stepIndex == 21) {
      dispatch(togglePauseTut());
    }
  }

  return (
    <AppBar position={'fixed'} sx={{ zIndex: theme => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <img src={logo} alt={'WZL logo'} style={{ maxHeight: 40 }} />
        <Button component={Link} color={'inherit'} to={'/'}>
          <Trans>Homepage</Trans>
        </Button>
        <Button component={Link} color={'inherit'} to={'/pipelines'}>
          <Trans>Pipelines</Trans>
        </Button>
        <Button component={Link} color={'inherit'} to={'/algorithm'}>
          <Trans>Algorithms</Trans>
        </Button>
        <div className='navbarResults-button'>
          <Button component={Link} color={'inherit'} to={'/results'} 
            onClick={handleResultsClick}
            >
            <Badge
              color="error"
              variant="dot"
              invisible={!newResult}
              anchorOrigin={{
                vertical: 'top', 
                horizontal: 'right'
              }}
            >
              <Trans>Results</Trans>
            </Badge>
          </Button>
        </div>
        <Button component={Link} color={'inherit'} to={'/assignments'}>
            <Trans>Assignments</Trans>
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        <IconButton onClick={()=>{dispatch(enableTut())}} size="large" color="inherit"><HelpIcon/></IconButton>
        <LanguageMenu />
        <UserMenu />
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar;
